module.exports = __webpack_public_path__ + "media/newstyle/images/icon-speak-purple-2309bad6b4cbc26a3f10b1d37870ecf9.svg";